// ecolabAuth — login DIRECTO contra Ecolab. CoopNet (como News, como
// cualquier app del ecosistema) nunca crea usuarios ni valida
// contraseñas: eso es responsabilidad exclusiva de Ecolab. El frontend
// le pega a Ecolab, recibe el JWT, y ese JWT es el que se reusa contra
// el backend de CoopNet en cada request de negocio.
//
// Ver INSTRUCTIVO_TURNSTILE_APPS_FINAL.md y SSO_CROSS_APP_INTEGRACION.md.

const ECOLAB_BASE_URL = process.env.REACT_APP_ECOLAB_BASE_URL;

class EcolabAuthError extends Error {
  constructor(message, turnstileError = false) {
    super(message);
    this.name = 'EcolabAuthError';
    this.turnstileError = turnstileError;
  }
}

/** GET público, sin JWT — la Site Key se consulta al backend en vez de hardcodearla. */
export async function obtenerTurnstileSiteKey() {
  const resp = await fetch(`${ECOLAB_BASE_URL}/api/ecolab/auth/turnstile-sitekey`);
  if (!resp.ok) throw new EcolabAuthError('No se pudo obtener la configuración de seguridad de Ecolab.');
  const data = await resp.json();
  return data.siteKey;
}

/**
 * Login directo contra Ecolab. Devuelve { token, usuario } tal como
 * Ecolab lo entregue — el shape exacto de `usuario` depende de Ecolab,
 * no lo normalizamos aquí (eso lo hace AuthContext al combinarlo con
 * el perfil propio de CoopNet).
 */
export async function loginEcolab(email, password, turnstileToken) {
  let resp;
  try {
    resp = await fetch(`${ECOLAB_BASE_URL}/api/ecolab/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password, turnstileToken }),
    });
  } catch {
    throw new EcolabAuthError('No se pudo conectar con Ecolab. Verifica tu conexión a internet.');
  }

  const data = await resp.json().catch(() => null);

  if (!resp.ok) {
    throw new EcolabAuthError(
      data?.mensaje || 'Credenciales inválidas.',
      Boolean(data?.turnstileError)
    );
  }

  return { token: data.token, usuario: data.usuario };
}

export { EcolabAuthError };
